import ScrollToTop from "@/components/Base/ScrollToTop";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./stores/store";
import Router from "./router";
import "./assets/css/app.css";
import "./i18n/i18n";
import { AppProvider } from "./use-context/Context";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from "@/pages/ErrorBoundary";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <BrowserRouter>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            <Provider store={store}>
                <AppProvider>
                    <Router />
                    <ToastContainer newestOnTop />
                </AppProvider>
            </Provider>
        </ErrorBoundary>
        <ScrollToTop />
    </BrowserRouter>
);

